var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.closeNoti,
          expression: "closeNoti",
        },
      ],
      staticClass: "noti-container",
    },
    [
      _c(
        "div",
        {
          staticClass: "noti-trigger",
          class: { "is-active": _vm.isOpen },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.toggleNoti.apply(null, arguments)
            },
          },
        },
        [
          _c("i", { staticClass: "el-icon-bell bell-icon" }),
          _vm.totalCountNotification > 0
            ? _c("span", { staticClass: "badge-count" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.totalCountNotification > 99
                        ? "99+"
                        : _vm.totalCountNotification
                    ) +
                    "\n      "
                ),
              ])
            : _vm._e(),
        ]
      ),
      _c("transition", { attrs: { name: "dropdown-fade" } }, [
        _vm.isOpen
          ? _c(
              "div",
              {
                staticClass: "noti-panel",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                  },
                },
              },
              [
                _c("div", { staticClass: "panel-header" }, [
                  _c("div", { staticClass: "header-content" }, [
                    _c("span", { staticClass: "title" }, [
                      _vm._v("Thông báo mới"),
                    ]),
                    _c("span", { staticClass: "dot" }),
                  ]),
                  _c("span", { staticClass: "sub-title" }, [
                    _vm._v(
                      _vm._s(_vm.totalCountNotification) + " mục cần xử lý"
                    ),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "panel-body custom-scrollbar" },
                  [
                    _vm._l(_vm.menuConfig, function (item) {
                      return [
                        _vm.checkPermission([item.permission]) &&
                        _vm.showCountData(item.title) > 0
                          ? _c(
                              "div",
                              {
                                key: item.key,
                                staticClass: "noti-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleItemClick(item)
                                  },
                                },
                              },
                              [
                                _c("div", { staticClass: "noti-item-inner" }, [
                                  _c("div", { staticClass: "icon-box" }, [
                                    _c("i", { class: item.icon }),
                                  ]),
                                  _c("div", { staticClass: "info-box" }, [
                                    _c("span", { staticClass: "item-name" }, [
                                      _vm._v(_vm._s(item.title)),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "count-pill" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.showCountData(item.title)) +
                                        "\n                "
                                    ),
                                  ]),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ]
                    }),
                    _vm.totalCountNotification === 0
                      ? _c("div", { staticClass: "empty-state" }, [
                          _c("div", { staticClass: "empty-icon" }, [
                            _c("i", { staticClass: "el-icon-message-solid" }),
                          ]),
                          _c("p", [_vm._v("Hiện tại không có thông báo mới")]),
                        ])
                      : _vm._e(),
                  ],
                  2
                ),
              ]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }